import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-journal-finder',
  templateUrl: './journal-finder.component.html',
  styleUrls: ['./journal-finder.component.scss']
})
export class JournalFinderComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinka 期刊查找｜為您的論文精準配對投稿期刊');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 的期刊查找功能透過分析您論文中的核心概念，並與數百萬筆既有出版資料與趨勢進行比對，協助您找到最合適的投稿期刊。幫助您節省選刊時間、提升發表機會，並最大化引用效益。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka 期刊查找｜為您的論文精準配對投稿期刊' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 的期刊查找功能透過分析您論文中的核心概念，並與數百萬筆既有出版資料與趨勢進行比對，協助您找到最合適的投稿期刊。幫助您節省選刊時間、提升發表機會，並最大化引用效益。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/journal-finder' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/s1.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka 期刊查找｜為您的論文精準配對投稿期刊' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka 的期刊查找功能透過分析您論文中的核心概念，並與數百萬筆既有出版資料與趨勢進行比對，協助您找到最合適的投稿期刊。幫助您節省選刊時間、提升發表機會，並最大化引用效益。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/features/s1.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/journal-finder' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/journal-finder' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/journal-finder' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/journal-finder' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/journal-finder' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/journal-finder' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/journal-finder' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/journal-finder' });
    
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
